import React from 'react';
import { MaskedInput as MaskedMaskedInput } from 'antd-mask-input';
import './Input.less';

const MaskedInput = props => <MaskedMaskedInput {...props} className="theme-input" />;


export default MaskedInput;
